import { Alert } from '@mui/material';

export const Forbidden = () => {
  return (
    <Alert severity="info">Forbidden access | RBAC</Alert>
  );
};
